/** Language settings rows get an `_id` (from `nanoid`) when they are added; use it as the React key. */
export const getRowKey = ({ _id: rowId }: { _id?: string }) => rowId;
